import { PageState, PageComponent } from "barba"

class FrameSelector {
    constructor({ node }) {
        // Props
        this.component = node;
        this.id = this.component.id;
        this.dropdown = this.component.querySelector('[data-frame-selector="dropdown"]');
        
        // Exit when there is only 1 frame
        if (!this.dropdown) return; 

        this.prevValue = this.dropdown.value;
        this.name = this.component.querySelector('[data-frame-selector="name"]');
        this.links = this.component.querySelectorAll('[data-frame-selector="link"]');
        this.image = this.component.querySelector('[data-frame-selector="image"]');
        this.imageTemplate = this.component.querySelector('[data-frame-selector="image-template"]')
        this.price = this.component.querySelector('[data-frame-selector="price"]');

        // Handlers
        this.changeHandler = this.change.bind(this);
        this.dropdown.addEventListener("change", this.changeHandler);  

        // Init
        this.updateUI();        
    }

    change(e) {
        // Save selection in page state
        var selectedOption = this.dropdown.options[this.dropdown.selectedIndex];
        PageState.set(this.id, selectedOption.value);
        
        // Update controls
        this.updateUI();
    }

    updateUI() {
        const selectedValue = PageState.get(this.id);
        
        if (typeof selectedValue !== "string") return;
        if (this.prevValue === selectedValue) return;

        this.prevValue = selectedValue;
        this.dropdown.value = selectedValue;
        const selectedOption = this.dropdown.options[this.dropdown.selectedIndex];

        if (!selectedOption) return;

        // Update link, image, price
        var ds = selectedOption.dataset;

        if (this.name) {
            this.name.innerText = ds.frameSelectorName;
        }

        if (this.links) {
            this.links.forEach(x => x.setAttribute("href", ds.frameSelectorUrl));
        }

        if (this.image && this.imageTemplate) {
            this.image.innerHTML = "";

            const imageKey = "%URL%";
            const imageUrl = ds.frameSelectorImage;

            let newImage = document.importNode(this.imageTemplate.content, true);
            newImage.querySelectorAll('[srcset]').forEach(x => x.srcset = x.srcset.replace(imageKey, imageUrl));
            newImage.querySelectorAll('[src]').forEach(x => x.src = x.src.replace(imageKey, imageUrl));
            this.image.append(newImage);
            newImage = null;
        }

        if (this.price) {
            this.price.innerHTML = ds.frameSelectorPrice;
        }
    }

    destroy() {
        // Events
        if (this.dropdown) this.dropdown.removeEventListener("change", this.changeHandler);  
        if (this.changeHandler) delete this.changeHandler;

        // Props
        if (this.component) delete this.component;
        if (this.id) delete this.id;
        if (this.dropdown) delete this.dropdown;
        if (this.prevValue) delete this.prevValue;
        if (this.name) delete this.name;
        if (this.links) delete this.links;
        if (this.image) delete this.image;
        if (this.imageTemplate) delete this.imageTemplate;
        if (this.price) delete this.price;
    }
}

new PageComponent('[data-frame-selector="component"]', FrameSelector);
